<template>
  <div v-if="accordion">
    <AccordionItem
      v-for="(item, ind) in accordion"
      :key="item.id"
      :item="item"
      :openFirstRow="firstItemOpen"
      :index="ind"
      :pageStyle="pageStyle"
      :item-id="item.id"/>
  </div>
</template>
<script>
import AccordionItem from './AccordionItem'

export default {
    components: {
      AccordionItem
    },
    props: {
        name: {
            type: String,
        },
        pageStyle: {
            type: String,
            default: '',
        },
    },
    computed: {
        accordion() {
            let accordionData = window?.capes?.[this.name] ?? [];

            // Handle both old format (array) and new format (object with items)
            let accordion = Array.isArray(accordionData) ? accordionData : (accordionData.items ?? []);

            if( !accordion.length ) {
                return []
            }

            return accordion.map((el, index) => {
              el.id = index
              return el;
            })
        },
        firstItemOpen() {
            // For about_accordion (experience pages) - get from global setting
            if (this.name === 'about_accordion' && window?.capes?.first_item_open) {
                return window.capes.first_item_open;
            }

            // For page builder accordions - get from the accordion data object
            const accordionData = window?.capes?.[this.name];
            if (accordionData && !Array.isArray(accordionData) && accordionData.open_first_row) {
                return accordionData.open_first_row;
            }

            return 'no';
        }
    },
};
</script>
